function replaceBodyTagWithDivTag(contents) {
	
	if (contents) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(contents, 'text/html');
		const bodyTag = doc.body; // 원본 body tag
		const divTag = document.createElement('div'); // 원본 body tag를 치환할 div tag

		for (const attr of bodyTag.attributes) { // body tag에 있는 속성을 div tag에 설정
			divTag.setAttribute(attr.name, attr.value);
		}

		while (bodyTag.firstChild) { // body tag의 모든 자식 요소를 div tag에 추가
			divTag.appendChild(bodyTag.firstChild);
		}

		return divTag.outerHTML;
	}

	return '';
}
  
export default replaceBodyTagWithDivTag;
  